import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Center,
  Heading,
  Text
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { LayoutContainer } from '../common';

const faqs = [
  {
    question: 'Why should I trust Clerk with my users?',
    answer: `<div><p>Security is always on our mind. We read and study <a href='https://pages.nist.gov/800-63-3/'>NIST guidelines</a> for fun.</p></br><p> We do external security audits every year, and for every feature written. We implement proactive security measures for your applications such as password breach detection, using a huge database of leaked passwords.</p> </br> <p> You can learn more about security at Clerk on our <a href='/docs/security/overview'>security</a> page. If you have any specific questions, <a href='/support'>contact us</a>, we love to nerd out about this stuff.</p><div>`
  },
  {
    question: 'What happens if I surpass 5000 MAUs on the free plan?',
    answer:
      "We won't stop people from signing in — however, we will ask you to upgrade to our 'Hobby' plan.  We've priced Clerk to be affordable for every type of company, (and much cheaper than the competition!)"
  },
  {
    question: 'What happens if I stop using Clerk?',
    answer:
      "We'd be sad to see you go!  We would greatly appreciate any feedback good or bad on how we could do better. However, we understand things happen and we make it really easy to export all of your data. Just <a href='/support'>contact us</a>, and we'll start an export for you.  <br><br>Note: that we store all passwords as a bcrypt hash, and cannot export raw passwords."
  },
  {
    question: 'Do you have any special offers for Startups?',
    answer:
      "We do! We have deals with a lot of seed accelerators and VCs.  Checkout our <a href='/startups'>startups page</a>  and reach out.  Once we verify your account, we'll be able to add your credits."
  }
];

export function FAQs(): JSX.Element {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    // This forces a rerender, so the date is rendered
    // the second time but not the first
    setHydrated(true);
  }, []);
  if (!hydrated) {
    // Returns null on first render, so the client and server match
    return <></>;
  }
  return (
    <LayoutContainer bg="white" verticalPadding="none" py="70px">
      <Center flexDir="column">
        <Heading as="h3" size="h2" mb={8}>
          FAQs
        </Heading>

        <Accordion w={{ lg: '572px' }} allowToggle>
          {faqs.map(({ answer, question }) => (
            <AccordionItem key={question} border="none">
              <AccordionButton
                py={5}
                borderBottom="1px solid"
                borderColor="gray.100"
              >
                <Text
                  flex="1"
                  textAlign="left"
                  textStyle="label-md"
                  color="gray.700"
                >
                  {question}
                </Text>

                <AccordionIcon color="gray.500" />
              </AccordionButton>

              <AccordionPanel py={6}>
                <Text
                  textStyle="paragraph-md"
                  color="gray.500"
                  dangerouslySetInnerHTML={{ __html: answer }}
                />
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Center>
    </LayoutContainer>
  );
}
